import { createContext } from 'react';
import type { CalendarLinkedContext } from '../utils/calendarSectionAcademicYear';

export type SharedCalendarLinkedValue = {
  workspaceId: string;
  gradeId: string;
  ctx: CalendarLinkedContext;
};

export const SharedCalendarLinkedContext = createContext<SharedCalendarLinkedValue | null>(null);
